import React from 'react';
import { Button, Modal, Typography } from 'antd';
import { LevelBadge } from './ruleDisplay';

const { Text } = Typography;

const sectionTitle: React.CSSProperties = { fontWeight: 600, fontSize: 15, margin: '18px 0 8px' };
const listStyle: React.CSSProperties = { margin: 0, paddingLeft: 20, lineHeight: '24px' };

/**
 * 页面级说明：规则适用的场景、三级规则的优先级、仓库在入库时按什么步骤执行。
 * 纯展示，不依赖页面数据。
 */
const RuleHelpModal: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => (
  <Modal
    title="退货入库初检说明"
    open={open}
    onCancel={onClose}
    width={720}
    footer={
      <Button type="primary" onClick={onClose}>
        知道了
      </Button>
    }
  >
    <div style={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: 4 }}>
      <div style={{ ...sectionTitle, marginTop: 0 }}>一、业务说明</div>
      <p style={{ margin: 0, lineHeight: '24px' }}>
        退货入库初检的主要目的：买家退货到仓时，仓库在收货的同时就先做一次初步检查，确认产品是否符合再售标准，并立即执行相应的处置——
        符合的作为正常产品入库，不符合的按规则销毁（或入异常库存
        AIU，留待以后批量处理）。这样可以加快库存周转、节省费用，
        也便于客户及时确认是否可以退款给买家。
      </p>

      <div style={sectionTitle}>二、适用场景</div>
      <ul style={listStyle}>
        <li>
          退货初检<Text strong>仅适用于</Text>在"入库管理 → 入库预报"中已创建
          <Text strong>"非常规预报（退货入库）"</Text>的货件。
        </li>
        <li>
          对于<Text strong>未提前预报</Text>的入库货件（如 Amazon
          移除等场景），以及只有常规入库预报的货件， 接收到的异常库存
          <Text strong>不会自动执行退货初检</Text>，而是统一进入异常库存（AIU），留待以后批量处理。
        </li>
        <li>
          创建退货入库预报前，必须已有生效的规则（库存单元级、项目级或通用规则任一级）；通用规则为兜底，建议先设置。
        </li>
      </ul>

      <div style={sectionTitle}>三、规则适用范围与优先级</div>
      <div style={{ marginBottom: 8 }}>
        可设置3级规则，优先级由低到高分别为：通用规则&gt;项目级规则&gt;库存单元级规则
      </div>
      <ul style={listStyle}>
        <li>
          <LevelBadge level="customer" outlined />
          　适用于所有项目的所有库存单元，作为兜底。
        </li>
        <li>
          <LevelBadge level="project" outlined />
          　仅适用于某个项目的所有库存单元，优先于通用规则。
        </li>
        <li>
          <LevelBadge level="inventory_unit" outlined />
          　仅适用于某个项目的特定库存单元，优先级最高。
        </li>
      </ul>

      <div style={sectionTitle}>四、仓库执行退货预报入库的步骤</div>
      <ol style={listStyle}>
        <li>
          <Text strong>确定库存单元</Text>：扫描退货货件，按退货入库预报确定对应的库存单元。
        </li>
        <li>
          <Text strong>依次查找规则</Text>：先找该库存单元的
          <LevelBadge level="inventory_unit" outlined />
          ，没有再找所属项目的
          <LevelBadge level="project" outlined />
          ，仍没有再找
          <LevelBadge level="customer" outlined />
          ，使用找到的第一条。
        </li>
        <li>
          <Text strong>按规则设置分流处理</Text>：
          <ul style={{ ...listStyle, paddingLeft: 18 }}>
            <li>所有退货直接销毁：不做任何检查，直接销毁。</li>
            <li>所有退货入 AIU 待处理：不做任何检查，入异常库存（AIU），留待以后批量处理。</li>
            <li>
              按流程初检：先对照外观基准，判定"一致/不一致"；再按规则里为该结果设置的处置执行（作为正常产品入库、入
              AIU、销毁，
              或继续对照内件基准）。继续检查内件时，同样判定"符合/不符"，再按规则里设置的处置执行。每个结果之后做什么，
              由客户在库存单元级规则里自行设置。外包装为吸塑/塑封的，可打开"外包装为吸塑/塑封包装"开关，外观改按"包装是否完好"判定。
            </li>
          </ul>
        </li>
      </ol>
    </div>
  </Modal>
);

export default RuleHelpModal;
